import Page from 'v5/chapterMembers/ChapterMembersPageRelay.bs'
import { withMainLayoutFlex } from '../../pagesComponents/MainApp'
import { requireAuthenticatedAgent } from '../../hoc/AuthenticatedComponent'

const MembersPage = requireAuthenticatedAgent(Page)

MembersPage.getLayout = withMainLayoutFlex

export default MembersPage
